var _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserChatBubbles(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.7,
    height: 22.05,
    viewBox: "0 0 21.7 22.05",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "user-chat-bubbles") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user-chat-bubbles"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.6,16a2.3,2.3,0,1,1,2.3-2.3A2.26,2.26,0,0,1,12.6,16Zm0-4a1.7,1.7,0,1,0,1.7,1.7A1.63,1.63,0,0,0,12.6,12Z",
    transform: "translate(-1.9 -0.9)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5,19.8c0-1.4,1.4-2.5,3.2-2.5s3.2,1.1,3.2,2.5a.3.3,0,1,0,.6,0c0-1.7-1.7-3.1-3.8-3.1S8.9,18,8.9,19.8a.27.27,0,0,0,.3.3A.45.45,0,0,0,9.5,19.8Z",
    transform: "translate(-1.9 -0.9)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.3,22.1A6.7,6.7,0,1,1,19,15.4,6.7,6.7,0,0,1,12.3,22.1Zm0-12.4a5.76,5.76,0,0,0-5.7,5.7,5.7,5.7,0,1,0,5.7-5.7Z",
    transform: "translate(-1.9 -0.9)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.4,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.8,22.6l1.3-1.3a.49.49,0,0,0-.7-.7L5.1,21.9a.48.48,0,0,0,0,.7.37.37,0,0,0,.3.1C5.6,22.7,5.8,22.7,5.8,22.6Z",
    transform: "translate(-1.9 -0.9)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M17.7,8.5a.6.6,0,0,1-.3-.6V7.4a1.93,1.93,0,0,1-1.8-2.1V3.2a2,2,0,0,1,2.1-2.1h3.6a2,2,0,0,1,2.1,2.1V5.4a2,2,0,0,1-2.1,2.1H19.9l-1.5,1A.85.85,0,0,1,17.7,8.5Zm3.6-6.9H17.7a1.42,1.42,0,0,0-1.5,1.5V5.3a1.42,1.42,0,0,0,1.5,1.5.32.32,0,0,1,.3.3V8h.1l1.6-1.1h1.6a1.42,1.42,0,0,0,1.5-1.5V3.2A1.45,1.45,0,0,0,21.3,1.6Z",
    transform: "translate(-1.9 -0.9)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.4,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6,3a.43.43,0,0,1,.4.4.43.43,0,0,1-.4.4H17.7a.43.43,0,0,1-.4-.4.43.43,0,0,1,.4-.4Z",
    transform: "translate(-1.9 -0.9)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7,5c.2,0,.3.2.3.4a.45.45,0,0,1-.3.4H18.6c-.2,0-.3-.2-.3-.4s.1-.4.2-.4Z",
    transform: "translate(-1.9 -0.9)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "Capa_120",
    "data-name": "Capa 120"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.1,8.5l-1.5-1H4.2A2,2,0,0,1,2.1,5.4V3.2A2,2,0,0,1,4.2,1.1H7.8A2.11,2.11,0,0,1,9.9,3.2V5.4A2.06,2.06,0,0,1,8.1,7.5V8a.86.86,0,0,1-.3.6A.82.82,0,0,1,7.1,8.5ZM2.6,3.2V5.4A1.42,1.42,0,0,0,4.1,6.9H5.7L7.3,8h.1V7.2a.32.32,0,0,1,.3-.3A1.42,1.42,0,0,0,9.2,5.4V3.2A1.42,1.42,0,0,0,7.7,1.7H4.2A1.5,1.5,0,0,0,2.6,3.2Z",
    transform: "translate(-1.9 -0.9)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.4,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.9,3.1a.43.43,0,0,0-.4.4.43.43,0,0,0,.4.4H7.8a.43.43,0,0,0,.4-.4.43.43,0,0,0-.4-.4Z",
    transform: "translate(-1.9 -0.9)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.8,5.2a.32.32,0,0,0-.3.3.45.45,0,0,0,.3.3H6.9a.3.3,0,0,0,0-.6Z",
    transform: "translate(-1.9 -0.9)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.4
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.91,6.72",
    transform: "translate(-1.9 -0.9)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserChatBubbles);
export default __webpack_public_path__ + "static/media/user-chat-bubbles.56409d93d7c2baa4598227e635340605.svg";
export { ForwardRef as ReactComponent };